import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    language: '',
    category: '',
    pptURL: '',
    pdfURL: '',
};

export const appSlice = createSlice({
    name: 'app',
    initialState,
    reducers: {
        updatePptURL: (state, action) => {
            state.pptURL = action.payload;
        },
         updatePdfURL: (state, action) => {
            state.pdfURL = action.payload;
        },
        changeLanguage: (state, action) => {
            state.language = action.payload;
        },
        changeCategoryState: (state, action) => {
            state.category = action.payload;
        },
        resetLanguage: (state) => {
            state.language = '';
        },
        resetCategoryState: (state) => {
            state.category = '';
        },
    },
});

// Action creators are generated for each case reducer function
export const { resetLanguage, changeLanguage, changeCategoryState, resetCategoryState, updatePptURL, updatePdfURL } =
    appSlice.actions;

export const getLanguage = (state) => state.app.language;
export const getCategoryState = (state) => state.app.category;
export const getPptURL = (state) => state.app.pptURL;
export const getPdfURL = (state) => state.app.pdfURL;

export default appSlice.reducer;
